import React from "react";
import { Spinner } from "reactstrap";

export const Loader = () => (
  <div className="d-flex">
    <Spinner type="grow" className="m-auto" color="black" />
  </div>
);
